import React, { useEffect, useMemo, useState } from "react";
import { flattenCategories } from "../../utils/flattenCategories";
import { useExhibitorCategory } from "./hooks/useExhibitorCategory";

export default function ExhibitorCategoryForm({
  initialData,
  onSubmit,
}) {
  const { data: categories, loadCategories } = useExhibitorCategory();

  const companyId = localStorage.getItem("company_id");

  const [form, setForm] = useState({
    name: "",
    parent_id: "",
  });

  useEffect(() => {
    if (companyId) {
      loadCategories(companyId);
    }
  }, [companyId]);

  useEffect(() => {
    if (initialData) {
      setForm({
        name: initialData.name || "",
        parent_id:
          initialData.parent_id?._id ||
          initialData.parent_id ||
          "",
      });
    }
  }, [initialData]);

  const parentCategories = useMemo(
    () => flattenCategories(categories || []),
    [categories]
  );

  const handleSubmit = (e) => {
    e.preventDefault();

     const payload = new FormData();
  payload.append("company_id", companyId);
  payload.append("name", form.name);

  if (form.parent_id) {
    payload.append("parent_id", form.parent_id);
  }

    onSubmit(payload);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 p-4">

      <div>
        <label className="block text-sm mb-1">
          Parent Category
        </label>
        <select
          value={form.parent_id}
          onChange={(e) =>
            setForm({ ...form, parent_id: e.target.value })
          }
          className="w-full rounded border px-3 py-2"
        >
          <option value="">Parent Category (Optional)</option>
          {parentCategories.map((cat) => (
            <option key={cat._id} value={cat._id}>
              {cat.title}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="block text-sm mb-1">
          Category Name<span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          value={form.name}
          onChange={(e) =>
            setForm({ ...form, name: e.target.value })
          }
          className="w-full rounded border px-3 py-2"
          required
        />
      </div>

      <div className="flex justify-end">
        <button
          type="submit"
          className="rounded bg-blue-600 px-4 py-2 text-white"
        >
          Save
        </button>
      </div>
    </form>
  );
}
